import React from "react";
import "./PrivacyPolicy.css";
const PrivacyPolicy = () => {
  return (
    <>
      <section className="about-section pb-5">
        <div className="about-title">
          <h4 data-aos="fade-down" data-aos-duration="2000">
            Platform policy
          </h4>
        </div>

        <div className="container">
          <div
            className="benefits-gold-investment-services-area"
            data-aos="fade-up"
            data-aos-duration="3000"
          >
            <div className="benefits-gold-investment-services pt-5">
              <h5># Disclaimer: </h5>
              <div
                className="forex-key-features"
                data-aos="fade-up"
                data-aos-duration="3000"
              >
                <p>
                  The cryptocurrency market is highly speculative and carries
                  significant risks, including sudden price fluctuations,
                  potential market manipulation, and technical failures. WLF
                  provides a free online trading platform for enthusiasts in
                  stocks, gold, cryptocurrency, and forex and Mining facilities.
                  However, WLF does not assume responsibility for the investment
                  performance of cryptocurrencies and does not guarantee any
                  profits or returns.
                </p>
              </div>
            </div>
          </div>

          <div
            className="benefits-gold-investment-services-area"
            data-aos="fade-up"
            data-aos-duration="3000"
          >
            <div className="benefits-gold-investment-services">
              <h5>WLF and its users agree to the following terms:</h5>
              <div className="benefits-gold-investment-services-list custom-lists ">
                <ol>
                  <li>
                    <p>
                      <b>Risk Awareness: &nbsp;</b>
                      Before engaging in any trading activities, users must
                      fully understand the nature of the market, evaluate their
                      financial capacity, and determine their individual risk
                      tolerance.
                    </p>
                  </li>
                  <li>
                    <p>
                      <b> Investment Risk:&nbsp;</b>
                      Digital asset trading involves substantial risk. Users
                      should be aware that they may lose part or all of their
                      invested capital.
                    </p>
                  </li>
                  <li>
                    <p>
                      <b> Market Information:&nbsp;</b>
                      WLF does not guarantee the accuracy, reliability, or
                      relevance of any market analysis or third-party
                      information. Users assume full responsibility for their
                      trading decisions and any resulting outcomes.
                    </p>
                  </li>
                  <li>
                    <p>
                      <b> Legal Compliance:&nbsp;</b>
                      WLF may disclose user data or take necessary actions in
                      compliance with legal or regulatory requirements. WLF
                      shall not be liable for any privacy concerns or
                      operational disruptions arising from such actions.
                    </p>
                  </li>
                  <li>
                    <p>
                      <b> Regulatory Changes:&nbsp;</b>
                      Users are solely responsible for any financial losses
                      caused by restrictions, suspensions, or prohibitions on
                      digital asset trading due to changes in applicable laws or
                      regulations.
                    </p>
                  </li>
                  <li>
                    <p>
                      <b> Final Authority:&nbsp;</b>
                      WLF reserves the ultimate right of interpretation of the
                      WLF Service Agreement and related policies.
                    </p>
                  </li>
                </ol>
              </div>
            </div>
          </div>

          <div
            className="benefits-gold-investment-services-area"
            data-aos="fade-up"
            data-aos-duration="3000"
          >
            <div className="benefits-gold-investment-services pt-5">
              <h5># Privacy Policy: </h5>
              <div className="benefits-content-area">
                <ul>
                  <li data-aos="fade-up" data-aos-duration="3000">
                    At WLF, your privacy is our top priority. We understand the
                    importance of safeguarding the information stored on our
                    servers or network — particularly data that relates to an
                    identifiable individual. The information we protect,
                    referred to as “Personal Data,” includes any data that can
                    directly or indirectly identify you.
                  </li>
                  <li data-aos="fade-up" data-aos-duration="3000">
                    This Privacy Policy is designed to meet the regulatory
                    standards of the jurisdictions in which WLF operates,
                    including compliance with the General Data Protection
                    Regulation (GDPR) established by the European Commission and
                    the California Consumer Privacy Act (CCPA). In this
                    document, the terms “Service” and “Services” refer to the
                    same definitions provided in our User Agreement.
                  </li>
                  <li data-aos="fade-up" data-aos-duration="3000">
                    This Privacy Notice applies to all processing of Personal
                    Data on the WLF website and any other affiliated sites where
                    it is displayed (collectively referred to as the “Sites”).
                    If you do not agree with this Privacy Policy, either in
                    whole or in part, you should refrain from using our Sites or
                    Services.
                  </li>
                  <li data-aos="fade-up" data-aos-duration="3000">
                    WLF reviews this Privacy Policy periodically to ensure it
                    reflects current legal obligations and aligns with changes
                    to our operations and business model. We reserve the right
                    to modify this Privacy Policy at any time by publishing an
                    updated version on our website.
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div
            className="benefits-gold-investment-services-area"
            data-aos="fade-up"
            data-aos-duration="3000"
          >
            <div className="benefits-gold-investment-services">
              <div className="benefits-gold-investment-services-list custom-lists ">
                <ol>
                  <li>
                    1. Who We Are and How to Contact Us
                    <p>
                      The organization responsible for ensuring that your
                      Personal Data is handled in full compliance with
                      applicable privacy and data protection laws is Saint Bitts
                      LLC, located at Nelson Springs Commercial Complex, Calhoun
                      Estate, Nevis, under company number L17015 (the “Data
                      Controller”).
                      <br />
                      <br />
                      If you have any questions, concerns, or wish to exercise
                      your rights regarding your Personal Data, you may contact
                      our Data Protection Officer (DPO) at WLF for assistance.
                    </p>
                  </li>

                  <li>
                    2. What Data We Collect and How We Collect It
                    <p>
                      We collect your Personal Data through several means —
                      directly from you, from third-party sources, or
                      automatically through the use of our Services.
                      <br />
                      <br />
                      <b>a.&nbsp;</b> Information You Provide to Us
                      <br />
                      <br />
                      You may provide information about yourself by filling out
                      forms on our Sites or mobile app, or through direct
                      communication (via phone, email, or other means). This may
                      include:
                      <br />
                      <br />
                      <b>Account Information:&nbsp;</b>
                      To create and manage your account, we may collect details
                      such as your name, date of birth, nationality, country of
                      residence, gender, occupation, contact details (phone,
                      email, and address), signature, photographs, professional
                      information, and identification documents (e.g., passport,
                      driver’s license, national ID, or visa information).
                      Additional information such as tax ID, social security
                      number, or utility bills may be requested to comply with
                      regulatory obligations.
                      <br />
                      <br />
                      <b>Financial and Transactional Information:&nbsp;</b>
                      We collect data related to your transactions, including
                      wallet addresses, bank account details, transaction
                      histories, payment sources, recipient information, and
                      beneficiary details. This allows us to process
                      transactions, verify funding sources, and maintain
                      compliance with financial regulations.
                      <br />
                      <br />
                      <b>Communication Data:&nbsp;</b>
                      When you contact us for support, subscribe to newsletters,
                      or request information, we may collect your email address,
                      phone number, or mailing address, as well as the content
                      of your communications.
                      <br />
                      <br />
                      <b>Surveys and Feedback:&nbsp;</b>
                      If you participate in our surveys or feedback initiatives,
                      we may collect responses and opinions you choose to share
                      with us.
                      <br />
                      <br />
                      <b>Interactive and Public Features:&nbsp;</b>
                      Any personal information you submit through public or
                      interactive features (e.g., chat rooms, forums, blogs, or
                      social media) may become publicly visible and is not
                      covered by this Privacy Policy unless required by law.
                      <br />
                      <br />
                      <b>Promotions, Contests, and Events:&nbsp;</b>
                      We may collect personal information for promotional
                      campaigns, sweepstakes, or events you participate in. In
                      certain jurisdictions, we may be required to disclose
                      information about winners.
                      <br />
                      <br />
                      <b>Business Partnerships and Networking:&nbsp;</b>
                      We may gather information through conferences, trade
                      shows, and partnership discussions to evaluate potential
                      business opportunities.
                      <br />
                      <br />
                      <b>b.&nbsp;</b> Information Collected Automatically
                    </p>
                  </li>

                  <li>
                    <br />
                    <br />
                    When you use our Services, certain data may be collected
                    automatically, including:
                    <br />
                    <br />
                    <p>
                      <b>Technical Information:&nbsp;</b> IP address, MAC
                      address, browser type, device model, operating system,
                      cookie identifiers, and network information.
                      <br />
                      <br />
                      <b>Usage Data:&nbsp;</b> Pages visited, time spent on each
                      page, navigation patterns, links clicked, and overall
                      interaction with the Sites or Services.
                      <br />
                      <br />
                      <b>Location Information:&nbsp;</b> Approximate or precise
                      location based on your IP address or device settings.
                      <br />
                      <br />
                      <b>Device Information:&nbsp;</b> Hardware specifications
                      and operating system version (collected anonymously).
                      <br />
                      <br />
                      <b>Transaction Information:&nbsp;</b> Details related to
                      crypto or fiat transactions executed through WLF Wallet
                      (such as currency exchanges and purchases).
                      <br />
                      <br />
                      <b>
                        c. Information Collected to Comply with Legal
                        Requirements
                      </b>
                      <br />
                      <br />
                      We are legally obligated to collect specific information
                      for Know Your Customer (KYC) and Anti-Money Laundering
                      (AML) compliance. This includes:
                      <br />
                      <br />
                      Full name, date and place of birth, and nationality
                      <br />
                      <br />
                      Residential address and contact information
                      <br />
                      <br />
                      Bank or payment details
                      <br />
                      <br />
                      Identification documents (passport, driver’s license, or
                      national ID)
                      <br />
                      <br />
                      Source of funds and proof of address
                      <br />
                      <br />
                      Status as a politically exposed person (PEP)
                      <br />
                      <br />
                      Transaction history and account balances
                      <br />
                      <br />
                      d. Information from External Sources
                      <br />
                      <br />
                      We may receive information from third-party sources to
                      enhance our Services or verify data accuracy. These
                      include:
                      <br />
                      <br />
                      Banks and Payment Processors: Providing basic identity and
                      account information for transactions.
                      <br />
                      <br />
                      Advertising and Analytics Providers: Offering anonymized
                      insights into website traffic and user engagement.
                      <br />
                      <br />
                      <b>Public Blockchain Data:</b> Used to ensure compliance
                      with our User Agreement and to detect potential illegal or
                      prohibited activities.
                      <br />
                      <br />
                      <b>Third-Party Service Providers:&nbsp;</b> Certain
                      services co-branded with WLF may collect information under
                      their own privacy policies.
                    </p>
                  </li>

                  <li>
                    <br />
                    <br />
                    e. Use of Cookies
                    <p>
                      We use cookies to enhance your experience and personalize
                      content. Cookies store small data files on your device,
                      allowing us to recognize your preferences and improve
                      functionality. For more details, please refer to our
                      Cookie Policy. You can manage cookie preferences through
                      your browser settings; however, disabling cookies may
                      limit some features of our Sites.
                    </p>
                  </li>

                  <li>
                    <br />
                    <br />
                    On What Legal Basis Do We Collect Your Data?
                    <p>
                      At WLF, we process your Personal Data only when we have a
                      valid legal basis for doing so. These legal bases include:
                      <br />
                      <br />
                      <b>1. Consent:&nbsp;</b>
                      In certain cases, we rely on your explicit consent to
                      process your Personal Data. This typically applies to
                      specific activities such as direct marketing that fall
                      under the scope of the GDPR. You will always be asked to
                      provide clear and affirmative consent — for example, by
                      checking a box — before any such processing occurs. You
                      may withdraw your consent at any time by contacting us at
                      [WLF email address].
                      <br />
                      <br />
                      <b>2. Performance of a Contract:&nbsp;</b>
                      We process your Personal Data when it is necessary for
                      fulfilling a contract to which you are a party, or to take
                      steps at your request prior to entering into such a
                      contract.
                      <br />
                      <br />
                      <b>3. Legal Obligation:&nbsp;</b>
                      In some instances, we are required to process your
                      Personal Data to comply with legal or regulatory
                      obligations, such as those under financial and anti-money
                      laundering laws (e.g., the Bank Secrecy Act). If we are
                      unable to collect the necessary information, we may not be
                      able to provide you with certain Services.
                      <br />
                      <br />
                      <b>4. Legitimate Interest:&nbsp;</b>
                      In most cases, we process Personal Data based on our
                      legitimate interests in operating and improving our
                      Services. These interests include preventing and detecting
                      fraud, maintaining the security of our systems, and
                      conducting statistical analysis.
                      <br />
                      <br />
                      Before relying on legitimate interests, we perform an
                      assessment to ensure that such processing does not
                      infringe upon your rights and freedoms. We do not rely on
                      legitimate interest for processing sensitive data, for
                      activities that would be unexpected, or where the impact
                      on your privacy would be disproportionate.
                    </p>
                  </li>

                  <li>
                    <br />
                    <br />
                    For What Purposes Do We Collect Your Data?
                    <p>
                      We collect and process your Personal Data for the
                      following purposes:
                      <br />
                      <br />
                      <b>To provide and improve our Services:&nbsp;</b> This
                      includes account setup and management, processing
                      transactions, offering customer support, and sending
                      notifications regarding your activities and transactions.
                      <br />
                      <br />
                      <b>To communicate with you:&nbsp;</b> We use your data to
                      respond to inquiries, resolve disputes, collect fees,
                      troubleshoot issues, and provide important updates about
                      your account or our Services.
                      <br />
                      <br />
                      <b>
                        To comply with legal and regulatory obligations:&nbsp;
                      </b>{" "}
                      We process data as required by applicable laws and
                      regulations, including anti-money laundering and financial
                      compliance requirements.
                      <br />
                      <br />
                      <b>To protect our legal interests:&nbsp;</b> Your
                      information may be used to establish, exercise, or defend
                      legal claims, and to monitor and report compliance-related
                      matters.
                      <br />
                      <br />
                      <b>To enhance our Services and operations:&nbsp;</b> We
                      analyze data to improve the quality, design, and
                      effectiveness of our Services, products, and websites.
                      This includes developing new features, performing audits,
                      managing communications, ensuring network security, and
                      maintaining high customer service standards.
                      <br />
                      <br />
                      <b>
                        To provide marketing and promotional
                        communications:&nbsp;
                      </b>{" "}
                      With your consent (where required by law), we may send
                      targeted marketing messages, promotional offers, and
                      service updates based on your preferences. You may opt out
                      at any time by following the unsubscribe link in our
                      communications.
                      <br />
                      <br />
                      <b>
                        To perform risk management and fraud prevention:&nbsp;
                      </b>{" "}
                      We use your data to verify information, protect against
                      unauthorized or illegal activities, and ensure compliance
                      with our contractual and operational requirements.
                    </p>
                  </li>

                  <li>
                    <br />
                    <br />
                    How Long Do We Keep Your Data?
                    <p>
                      We retain your Personal Data only for as long as necessary
                      to fulfill the purposes for which it was collected,
                      including to meet legal, regulatory, and reporting
                      obligations, or to resolve disputes. Retention periods may
                      vary depending on the type of data and applicable laws.
                      <br />
                      <br />
                      <b>
                        Contact Information (e.g., name, email, phone):&nbsp;
                      </b>{" "}
                      Retained for marketing purposes until you unsubscribe.
                      Once unsubscribed, your details are added to a suppression
                      list to prevent further communication.
                      <br />
                      <br />
                      <b>Legal and compliance data:&nbsp;</b> Information
                      required under financial and anti-money laundering laws
                      may be kept for the period mandated by law, even after
                      account closure.
                      <br />
                      <br />
                      <b>User-generated content:&nbsp;</b> Content such as
                      support requests, comments, images, or posts may be
                      retained after account closure for audit, fraud
                      prevention, or legal purposes.
                      <br />
                      <br />
                      <b>Technical and analytical data:&nbsp;</b> Data collected
                      through cookies or similar technologies is typically
                      retained for up to one year from the cookie’s expiration
                      date.
                      <br />
                      <br />
                      When your Personal Data is no longer needed for its
                      original purpose, we will either delete it securely or
                      anonymize it to prevent identification. However, certain
                      records may be preserved for up to five (5) years or
                      longer, as required by regulatory or anti-money laundering
                      obligations.
                    </p>
                  </li>

                  <li>
                    <br />
                    <br />
                    Who We Share Your Personal Data With
                    <p>
                      We may share your personal data with selected third
                      parties as necessary to provide our Services, fulfill
                      legal obligations, and help prevent or investigate
                      fraudulent or criminal activity. All such third parties
                      are contractually required to protect your data in
                      accordance with this Privacy Policy. The categories of
                      recipients include:
                      <br />
                      <br />
                      <b>1. WLF Affiliates</b>
                      <br />
                      Other WLF entities may access and share information to
                      help detect and prevent potential illegal activities,
                      enforce company policies, and support decisions regarding
                      our products, services, and communications.
                      <br />
                      <br />
                      <b>2. Service Providers</b>
                      <br />
                      We engage trusted third-party service providers who assist
                      us in delivering and improving our Services. These may
                      include:
                      <br />
                      <br />
                      Cloud infrastructure providers
                      <br />
                      <br />
                      Identity verification and compliance solution providers
                      (e.g., KYC and anti-money laundering)
                      <br />
                      <br />
                      Website analytics providers
                      <br />
                      <br />
                      Customer support platforms
                      <br />
                      <br />
                      Marketing automation providers
                      <br />
                      <br />
                      <b>3. Legal and Regulatory Authorities</b>
                      <br />
                      We may disclose data to law enforcement agencies,
                      government bodies, regulatory authorities, financial
                      institutions, or other relevant third parties when
                      required by law (e.g., via subpoena, court order, or other
                      legal processes). We may also share information when we
                      believe, at our sole discretion, that such disclosure is
                      necessary to report suspected illegal activity or enforce
                      our User Agreement.
                      <br />
                      <br />
                      <b>4. Business Transfers</b>
                      <br />
                      In the event of a merger, acquisition, divestiture,
                      restructuring, reorganization, dissolution, or other sale
                      or transfer of some or all WLF assets, your Personal Data
                      may be included among the transferred assets.
                      <br />
                      <br />
                      <b>5. Blockchain Data</b>
                      <br />
                      Certain funding and transaction details related to your
                      use of our Services may be recorded on a public
                      blockchain. Public blockchains are decentralized ledgers
                      designed to record transactions across extensive computer
                      networks permanently. As these ledgers are often publicly
                      accessible, blockchain data may be subject to forensic
                      analysis that could potentially reveal identifying
                      financial information when combined with other data
                      sources. Because such blockchains are not controlled or
                      operated by WLF or its affiliates, we cannot modify,
                      delete, or otherwise alter Personal Data recorded on them.
                    </p>
                  </li>

                  <li>
                    Is Your Data Transferred Outside the European Union?
                    <p>
                      As our operations are based outside the European Union, we
                      take appropriate measures to ensure that any transfer of
                      Personal Data from the EU is properly safeguarded. Any
                      processor, affiliate, or business partner transferring
                      Personal Data to us will be required to implement suitable
                      data protection measures.
                      <br />
                      <br />
                      When our service providers (Data Processors) or business
                      partners transfer your Personal Data to us from the
                      European Economic Area (EEA), we ensure that such
                      transfers are carried out lawfully and in compliance with
                      applicable data protection regulations.
                    </p>
                  </li>

                  <li>
                    <br />
                    <br />
                    What are your rights?
                    <p>
                      Your Rights Under the GDPR
                      <br />
                      <br />
                      Under the General Data Protection Regulation (GDPR) and
                      relevant implementing laws, individuals have certain
                      statutory rights concerning their Personal Data. Please
                      note that these rights are not absolute and may be subject
                      to specific legal conditions or limitations.
                      <br />
                      <br />
                      <b>Right to Object</b>
                      <br />
                      You have the right to object to the processing of your
                      Personal Data when such processing is based on our
                      legitimate interests (see above). In some cases, we may
                      demonstrate compelling legitimate grounds that justify
                      continued processing. However, if your Personal Data is
                      processed for direct marketing purposes, including
                      profiling related to direct marketing, we will always
                      respect your request to stop such processing.
                      <br />
                      <br />
                      <b>Other Rights Include:</b>
                      <br />
                      <br />
                      <b>Right to Withdraw Consent:</b> Where processing is
                      based on your consent, you may withdraw that consent at
                      any time.
                      <br />
                      <br />
                      <b>Right of Access:</b> You may request access to the
                      Personal Data we hold about you.
                      <br />
                      <br />
                      <b>Right to Rectification:</b> You may request correction
                      of any inaccurate or incomplete Personal Data.
                      <br />
                      <br />
                      <b>Right to Erasure:</b> You may request the deletion or
                      removal of your Personal Data under certain circumstances.
                      <br />
                      <br />
                      <b>Right to Restriction of Processing:</b> You may request
                      that we limit the processing of your Personal Data in
                      specific situations.
                      <br />
                      <br />
                      <b>Right to Data Portability:</b> In some instances, you
                      may request that your Personal Data be transferred to you
                      or to a third party of your choice.
                      <br />
                      <br />
                      The exercise of these rights is free of charge and can be
                      initiated through our Data Subject Request Portal or by
                      contacting us directly at WLF.
                      <br />
                      <br />
                      Before fulfilling your request, we may need to verify your
                      identity and/or request additional information to ensure
                      the security of your Personal Data. We will aim to respond
                      within one month of receiving your request. If your
                      request is particularly complex or involves a large volume
                      of data, we may extend this period by up to two additional
                      months, and we will inform you accordingly.
                    </p>
                  </li>
                </ol>
              </div>
            </div>
          </div>

          <div className="forex-key-features">
            <h5># Children’s Privacy: </h5>
            <p>
              WLF’s Services are not intended for individuals under the age of
              21, and we do not knowingly collect personally identifiable
              information from minors. If you are a parent or guardian and
              believe that your child has provided us with Personal Data, please
              contact us at WLF.
              <br />
              <br />
              If we discover that we have inadvertently collected Personal Data
              from a minor without verified parental consent, we will take
              prompt steps to delete that information from our systems.
            </p>
            <p>
              <span> Changes to This Privacy Policy</span>
              <br />
              We may update this Privacy Policy periodically to reflect changes
              in our data practices or legal requirements. However, we will not
              reduce your rights under this Privacy Policy without your explicit
              consent. Any updates will be posted on this page, and if the
              changes are significant, we will provide a clear and prominent
              notice. Previous versions of this Privacy Policy will be retained
              and made available for your review.
              <br />
              <br />
              We encourage you to review this Privacy Policy regularly to stay
              informed about how we protect your information. If you have any
              questions or concerns, please contact us at WLF.
              <br />
              <br />
              <b>Understanding Blockchain Technology</b>
              <br />
              <br />
              <span>What Is a Blockchain?</span>
              <br />
              <br />
              A blockchain is a sequence of interconnected data blocks, each
              containing specific information, linked together in chronological
              order. These blocks form a secure chain that ensures data
              integrity as long as at least one server (node) remains
              operational. Nodes in the network provide storage and computing
              power. To modify any blockchain record, approval from more than
              half of the participating nodes is required, and the change must
              be reflected across all nodes — making tampering extremely
              difficult.
              <br />
              <br />
              The two core characteristics of blockchain technology are
              immutability (data cannot be altered once recorded) and
              decentralization (no central authority controls the data).
              Together, these features make blockchain-stored information highly
              authentic, reliable, and resistant to manipulation — effectively
              addressing issues of trust between participants.
              <br />
              <br />
              <b>Origin of Blockchain</b>
              <br />
              <br />
              Blockchain technology originated from Bitcoin. On November 1,
              2008, a person (or group) using the pseudonym Satoshi Nakamoto
              <br />
              <b>published the white paper “Bitcoin:</b>
              <br /> A Peer-to-Peer Electronic Cash System.” The paper
              introduced an electronic cash framework based on peer-to-peer
              (P2P) networking, cryptographic encryption, timestamping, and
              blockchain technology—marking the birth of Bitcoin.
              <br />
              <br />
              Two months later, on January 3, 2009, the first “genesis block”
              (Block 0) was created. Shortly after, on January 9, 2009, Block 1
              was mined and linked to the genesis block, forming the first
              blockchain in history.
              <br />
              <br />
              Definition and Concept
              <br />
              <br />
              In a narrow sense, a blockchain is a chain-like data structure
              that links data blocks in chronological order, creating a
              cryptographically secured, tamper-resistant distributed ledger.
              <br />
              <br />
              In a broader sense, blockchain technology combines:
              <br />
              <br />
              Data verification and storage through chained block structures,
              <br />
              <br />
              Consensus algorithms among distributed nodes to generate and
              update data,
              <br />
              <br />
              Cryptography to secure data transmission and access, and
              <br />
              <br />
              Smart contracts, composed of self-executing code, to automate
              transactions.
              <br />
              <br />
              Together, these components form a new distributed infrastructure
              and computing paradigm for data management and programmable trust.
              <br />
              <br />
              <b>Development History</b>
              <br />
              <br />
              2008: Satoshi Nakamoto proposed the concept of blockchain as the
              foundation for Bitcoin — the first decentralized digital currency.
              By leveraging P2P networks and distributed timestamp servers,
              Bitcoin successfully solved the “double-spending” problem that
              plagued earlier digital money systems.
              <br />
              <br />
              <b>2014 – Blockchain 2.0:&nbsp;</b> The term Blockchain 2.0
              emerged, referring to programmable, decentralized blockchains
              capable of running complex “smart contracts.” This evolution
              enabled new use cases such as automated dividend distribution,
              peer-to-peer asset transfers, and digital identity systems — all
              without intermediaries. Blockchain 2.0 enhanced privacy, enabled
              individuals to monetize their data, and improved protection for
              intellectual property owners.
              <br />
              <br />
              <b>2019 – Policy Recognition:</b>
              <br />
              <br />
              On January 10, 2019, the State Internet Information Office issued
              the Blockchain Information Service Management Regulations.
              <br />
              <br />
              On October 24, 2019, during the 18th collective study session of
              the Political Bureau of the Central Committee, General Secretary
              Xi Jinping highlighted blockchain as a breakthrough for core
              technology innovation, calling for accelerated blockchain
              development and industrial application.
              <br />
              <br />
              Since then, blockchain has gained widespread public attention and
              become a major technological and social focus.
              <br />
              <br />
              <b>Types of Blockchains</b>
              <br />
              <br />
              <b>1. Public Blockchains</b>
              <br />
              <br />
              Public blockchains are open to anyone. Any user can send
              transactions and participate in the consensus process. They are
              the earliest and most widely used form of blockchain — with
              cryptocurrencies like Bitcoin and Ethereum being prime examples.
              Each digital currency typically operates on its own unique public
              blockchain.
              <br />
              <br />
              <b>2. Consortium Blockchains</b>
              <br />
              <br />
              Consortium blockchains are semi-decentralized systems governed by
              a group of pre-selected organizations or nodes that share
              responsibility for validating transactions and generating blocks.
              While the system remains distributed, it relies on trusted
              participants, and its main risks involve coordination and trust
              among those governing entities. Public APIs allow limited data
              access for external users.
              <br />
              <br />
              <b>3. Private Blockchains</b>
              <br />
              <br />
              Private blockchains are maintained by a single organization or
              entity for internal use. They employ the same underlying
              technology as public blockchains but restrict participation and
              access. While private blockchains are popular in finance and
              enterprise experimentation, large-scale industrial applications
              are still emerging.
              <br />
              <br />
              <b>Key Features of Blockchain</b>
              <br />
              <br />
              <b>1. Decentralization</b>
              <br />
              <br />
              Blockchain eliminates the need for central authorities or
              intermediaries. Each node independently verifies, transmits, and
              manages data, ensuring a self-sustaining and transparent system.
              <br />
              <br />
              <b>2. Openness</b>
              <br />
              <br />
              Most blockchain systems are open source. Apart from encrypted
              private information, all blockchain data is publicly accessible.
              Anyone can query blockchain information or develop related
              applications, ensuring system-wide transparency.
              <br />
              <br />
              <b>3. Independence</b>
              <br />
              <br />
              Blockchain networks operate autonomously based on consensus
              mechanisms and protocols (such as Bitcoin’s SHA-256 hash
              algorithm). This independence allows data validation and exchange
              to occur automatically, without third-party involvement.
              <br />
              <br />
              <b>4. Security</b>
              <br />
              <br />
              Blockchain’s security model ensures that as long as no single
              entity controls over 51% of the network’s nodes, data manipulation
              is practically impossible. This distributed trust mechanism makes
              the blockchain highly resistant to tampering or fraud.
              <br />
              <br />
              <b>5. Anonymity</b>
              <br />
              <br />
              Participants in blockchain transactions are not required to reveal
              their identities. Each node operates through cryptographic
              addresses, allowing for anonymous participation unless identity
              verification is legally mandated.
            </p>
          </div>
        </div>
      </section>
    </>
  );
};

export default PrivacyPolicy;
